import { useTranslation } from 'react-i18next';

const Hero = ({ lang, config, ruta }) => {

    let { t } = useTranslation();
    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    function getArrayCookie(nombre) {
        let nombreCookie = `${nombre}=`;
        let cookiesDecodificadas = decodeURIComponent(document.cookie);
        let arrayCookies = cookiesDecodificadas.split(';');

        for (let i = 0; i < arrayCookies.length; i++) {
            let cookie = arrayCookies[i].trim();
            if (cookie.indexOf(nombreCookie) === 0) {
                try {
                    return JSON.parse(cookie.substring(nombreCookie.length, cookie.length));
                } catch (e) {
                    console.error('Error parseando cookie:', e);
                    return null;
                }
            }
        }
        return null;
    }

    const cookieValue = getArrayCookie("datos");



    return (
        <>
            <div className="rw-header">
                <div init="false" pagination="true" className="c-swiper-hero c-rw-swiper-hero">
                    <div style={{ width: "1882px", opacity: "1", transform: "translate3d(0px, 0px, 0px)" }} role="group" aria-label="1 / 1" className="swiper-slide-visible swiper-slide-fully-visible swiper-slide-active">
                        {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/H10RW_Cabecera_APub1.jpg" alt="" />*/}
                        <img loading="lazy" src="/images/web/valesuites/headerrewards.png" alt="" />

                        <div className="container">
                            <div className="c-swiper-hero_txt" style={{ width: "100%" }}>
                                <figure>
                                    {
                                        config.logo !== "" ?
                                            <img loading="lazy" alt="" className="logo" src={ruta + "/web/logo/web/" + config.logo} style={{ maxWidth: "100px" }} />
                                            :
                                            config.logo_fiscal != "" ?
                                                <img loading="lazy" alt="" className="logo" src={ruta + "/web/logo/" + config.logo_fiscal} style={{ maxWidth: "100px" }} />
                                                :
                                                <img loading="lazy" alt="" className="logo" src="https://www.bedloop.com/imatges/logo.webp" style={{ maxWidth: "100px" }} />
                                    }
                                </figure>

                                <div style={{ display: "block" }}>
                                    <p className="c-rw-swiper-hero_title">{t("DONDE SIEMPRE ERES BIENVENIDO")}</p>
                                    <p> {t("Tu viaje siempre recompensado")}</p>

                                </div>
                                {
                                    !cookieValue ?
                                        <div className="flex-wrap gap-3 d-flex align-items-center justify-content-center">

                                            <a className="btn rw-btn btn-white" href={`/${preidioma}${t("altasocio")}`} style={{ borderRadius: "2.6em" }}>{t("QUIERO UNIRME")}</a>
                                            <a id="openLogin" type="button" className="btn rw-btn btn-outline-white" style={{ borderRadius: "2.6em" }} href={`/${preidioma}${t("loginweb")}`}>{t("YA SOY MIEMBRO")}</a>

                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </div>


                    </div>

                </div>
            </div>
        </>
    )
}

export default Hero;
